import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import CallsIcon from '@mui/icons-material/Campaign';
import MyApplies from '@mui/icons-material/AssignmentTurnedIn';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import AdminIcon from '@mui/icons-material/AdminPanelSettings';
import FormsIcon from '@mui/icons-material/Article';
import { Link } from "react-router-dom";

import Style from "../../../styles/js/Styles.js";

import service from "../../../plas/services/calls/service";

export default function Menu( { open, onExpand } ) {

  const style = Style();

  const [expanded, setExpanded] = React.useState(false);
  const [expandedAdmin, setExpandedAdmin] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setExpanded(false);
      setExpandedAdmin(false);
    }
  }, [open]);

  const onClick = () => {
    if (!expanded) {
      onExpand();
    }
    setExpanded(!expanded);
  }
  
  const onClickAdmin = () => {
    setExpandedAdmin(!expandedAdmin);
  }
  
  return (
    <div>
     { (service.canApply() || service.canAdmin()) ? (
        <div>
          <ListItem button onClick={onClick}>
            <ListItemIcon>
              <CallsIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Convocatorias" />
            { expanded && open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={expanded && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
            <List component="div">
              { service.canApply() ? (
                <div>
                  <ListItem button component={Link} to={"/calls/open-calls"} >
                  <ListItemIcon>
                    <CallsIcon/>
                  </ListItemIcon>
                  <ListItemText className={style.menuTextItem} primary="Convocatorias abiertas" />
                </ListItem>
                <ListItem button component={Link} to={"/calls/my-applications"}>
                  <ListItemIcon>
                    <MyApplies />
                  </ListItemIcon>
                  <ListItemText className={style.menuTextItem} primary="Mis postulaciones" />
                </ListItem>
              </div>) : (null) }
              { service.canAdmin() ? (
                <div>
                  <ListItem button onClick={onClickAdmin}>
                    <ListItemIcon>
                      <AdminIcon />
                    </ListItemIcon>
                    <ListItemText className={style.menuTextItem} primary="Administración" />
                    { expandedAdmin && open ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={expandedAdmin && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
                    <List component="div">
                      <ListItem button component={Link} to={"/calls/admin/calls"}>
                        <ListItemIcon>
                          <RuleFolderIcon />
                        </ListItemIcon>
                        <ListItemText className={style.menuTextItem} primary="Convocatorias" />
                      </ListItem>
                      <ListItem button component={Link} to={"/calls/admin/forms"}>
                        <ListItemIcon>
                          <FormsIcon />
                        </ListItemIcon>
                        <ListItemText className={style.menuTextItem} primary="Formularios" />
                      </ListItem>
                    </List>
                  </Collapse>
                </div>
                ) : (null)
              }
            </List>
          </Collapse>
        </div>) : (null) 
     }
    </div>
    
  );
}
